import { InjectProperty } from '@jack-henry/frontend-utils/di';
import '@jack-henry/jh-icons/icons-wc/icon-chevron-left-small.js';
import { NavigationService } from '@treasury/core/navigation';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../../tm-base.component';

const tagName = 'tm-bo-nav-back';

@customElement(tagName)
export class TmBoNavBack extends TmBaseComponent {
    @property({ type: String })
    public label = '';

    @property({ type: String })
    public target = '';

    @InjectProperty()
    declare private readonly navigationService: NavigationService;

    public render() {
        return html`<div class="w-[fit-content]">
            <a
                class="hover:underline flex items-center"
                href="javascript:void(0)"
                @click=${() => this.navigationService.navigate(this.target)}
            >
                <span class="flex items-center gap-2">
                    <jh-icon-chevron-left-small></jh-icon-chevron-left-small>
                    <p>${this.label}</p>
                </span>
            </a>
        </div>`;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static styles = css`
        :host {
            --jh-icon-color-fill: var(--jh-color-content-brand-enabled);
            a {
                color: var(--jh-color-content-brand-enabled);
            }
        }
    `;
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmBoNavBack;
    }
}
